import { render, staticRenderFns } from "./Breathing.vue?vue&type=template&id=9c6e44a6&"
import script from "./Breathing.vue?vue&type=script&lang=js&"
export * from "./Breathing.vue?vue&type=script&lang=js&"
import style0 from "./Breathing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Breathing.vue"
export default component.exports